import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CONFIRM_SOLICITUD_ERROR, SELECTED_BANK, SOLICITUD_VIA_PAGO_RESPONSE } from '@constants/cambio-via-pago-properties.constants';
import { INICIO, ROUTING_CAMBIO_VIA_PAGO_PENSION } from '@constants/url.constant';
import { ISelectedBank } from '@interfaces/seleted-bank.interface';
import { StorageService } from '@services/storage/storage.service';
import { Util } from '@shared/common/utils/util';
import { CambioViaPagoPensionService } from 'src/app/cambio-via-pago-pension/core/services/cambio-via-pago-pension.service';
import { GenericErrorOps } from '../generic-error/interfaces/generic-error-ops.interface';

@Component({
    selector: 'app-solicitud-error',
    templateUrl: './solicitud-error.component.html',
    styleUrls: ['./solicitud-error.component.scss'],
    standalone: false
})
export class SolicitudErrorComponent implements OnInit {

  ops: GenericErrorOps = CONFIRM_SOLICITUD_ERROR;
  retryAttempt: boolean= false;
  token: string;
  cuentaBancariaSeleccionada: ISelectedBank;
  nAttempts:number = 0;
  attempt: boolean = false;

  constructor( private readonly _cambioViaPagoPensionService: CambioViaPagoPensionService, 
               private readonly storageService: StorageService,
               private readonly _router: Router,
               private readonly _util: Util,
               ) { }

  async ngOnInit()  {

    this.cuentaBancariaSeleccionada = await this.storageService.get(SELECTED_BANK);
    this.token = await this._util.getIdToken();
     
  }

  retryEvent(){
    this.retryAttempt = true;
    this.nAttempts++;
    if (this.nAttempts <= 3 ) {
      this.loadServices();
   }

  }

  goToEvent(){
    this._router.navigate([INICIO]);
  }

  loadServices(){
    this._cambioViaPagoPensionService.solicitudCambioViaPago(this.token,this.cuentaBancariaSeleccionada)
    .subscribe(res => {
     this.attempt = false;
     this.storageService.set(SOLICITUD_VIA_PAGO_RESPONSE, res)
     this._router.navigate([
       ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_BASE,
       ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_URL,
       ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_COMPROBANTE
     ])
    }, () => {
     this.getErrorSolicitud();
    })
  }

  getErrorSolicitud(){
    if (this.nAttempts === 3) {
      this.retryAttempt = false;
      this.nAttempts = 0;
      this._router.navigate([
        ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_BASE,
        ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_URL,
        ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_HOME
      ]);
  }

    this.retryAttempt = false;
  }

}
